import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-start">
          {/* Left - Logo and Tagline */}
          <Col lg={7} md={12} className="mb-4 mb-lg-0">
            <div className="footer-brand">
              <div className="nisa-logo">
                <img
                  src="/images/footer-logo.png"
                  alt="Nisa Care Logo"
                  className="footer-logo"
                />
              </div>
              <p className="footer-tagline">
                Your health, honored. Your faith, respected.<br />
                Your journey, supported at every age
              </p>
            </div>
          </Col>

          {/* Right - Three Columns */}
          <Col lg={5} md={12}>
            <Row>
              {/* App Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">App</h6>
                <ul className="footer-links">
                  <li><a href="#journey">Journey</a></li>
                  <li><a href="#features">Features</a></li>
                </ul>
              </Col>

              {/* Legal Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">Legal</h6>
                <ul className="footer-links">
                  <li><a href="#privacy">Privacy Policy</a></li>
                  <li><a href="#terms">Terms of Use</a></li>
                  <li><a href="#data">Data</a></li>
                </ul>
              </Col>

              {/* Social Column */}
              <Col sm={4} xs={12} className="mb-4">
                <h6 className="footer-heading">Social</h6>
                <ul className="footer-links">
                  <li><a href="https://www.instagram.com/nisacareofficial?igsh=MTdua3RkbTQ0cXMyeg==" target="_blank">instagram</a></li>
                  {/* <li><a href="#tiktok" target="_blank">Tiktok</a></li> */}
                  <li><a href="https://x.com/nisacare_?s=21&t=QwKzcKjRZEKeqRumc2Wt8g" target="_blank">X</a></li>
                  <li><a href="https://www.facebook.com/share/1DZACKQ5NN/?mibextid=wwXIfr" target="_blank">Facebook</a></li>
                  {/* <li><a href="#contact" target="_blank">Contact</a></li> */}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;